import { useTheme } from 'next-themes'
import { Toaster as Sonner, ToasterProps } from 'sonner'
import CheckmarkIcon from 'src/core/icons/CheckmarkIcon'
import ErrorIcon from 'src/core/icons/ErrorIcon'
import WarningIcon from 'src/core/icons/WarningIcon'

const TOAST_VISIBILITY_DURATION = 3000

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = 'system' } = useTheme()

	return (
		<Sonner
			expand
			theme={theme as ToasterProps['theme']}
			className="toaster group"
			style={
				{
					zIndex: 49,
					'--normal-bg': 'var(--white)',
					'--normal-text': 'var(--black)',
					'--normal-secondary-grey': 'var(--secondary-grey)',
				} as React.CSSProperties
			}
			icons={{
				success: <CheckmarkIcon className="text-success" />,
				warning: <WarningIcon className="text-warning" />,
				error: <ErrorIcon className="text-destructive" />,
			}}
			toastOptions={{
				classNames: { icon: '!mr-3' },
			}}
			offset={{ bottom: 80 }}
			duration={TOAST_VISIBILITY_DURATION}
			{...props}
		/>
	)
}

export { Toaster }
